import React, { useEffect, useState } from "react";
import {
  Table,
  InputNumber,
  Tag,
  Space,
  Button,
  Card,
  Input,
  Form,
  notification,
  Select,
} from "antd";
import { addModuleAction } from "../../redux/actions/courseActions";
import { connect } from "react-redux";
import { Editor } from "@tinymce/tinymce-react";
import { useHistory } from "react-router-dom";

import queryString from "query-string";

const { REACT_APP_EDITOR_KEY: apiKey } = process.env;

const AddModule = ({ addModuleAction, moduleState, match,location }) => {
  const history = useHistory();


  const { week} = queryString.parse(location.search);

  const weekTitle= week==1?"Module week in One Week":"Module week in "+week+" weeks";

  const [state, setState] = useState({
    key: "new",
  });
  const [moduleContent, setModuleContent] = useState("");
  const [disablePublish, setDisablePublish] = useState(true);
  const [moduleInfo, setModuleInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const courseName = match.params.courseName;

  const onTabChange = (key, type) => {
    console.log(key, type);
    setState({ [type]: key });
  };
  const handleEditorChange = (content, editor) => {
    setDisablePublish(false);
    setModuleContent(content);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setModuleInfo({
      ...moduleInfo,
      [name]: value,
    });
    console.log("@@@@@@@@@@",moduleInfo);
    setDisablePublish(false);
  };

  const handleSubmit = (value) => {
    setLoading(true);
    const payload = {
      ...moduleInfo,
      description: moduleContent,
      courseName,
    };
    console.log("!!!@@@@@@@@@@",payload);
    addModuleAction(payload);
  };

  useEffect(() => {
    if (moduleState.newModuleData) {
      setLoading(false);
      notification.success({ message: "Module added successfully" });
      history.push(`/dashboard/courses/${courseName}/module-management`);

      setTimeout(() => {
        window.location.reload(); 
      }, 1000);

    }
    if (moduleState.newModuleError) {
      setLoading(false);
      notification.error({
        message: "Failed to add module. Please, try again!",
      });
      window.location.reload();
    }
  }, [moduleState]);

  const tabList = [
    {
      key: "new",
      tab: "Create new",
    },
    {
      key: "preview",
      tab: "Preview",
    },
  ];
  const children = [];

  const contentList = {
    // Module content here
    new: (
      <div>
      <Form.Item
        name="moduleName"
        label="Module name"
        rules={[
          { required: true, message: "Please provide the module name" },
        ]}
      >
        <Input
          size="large"
          name="moduleName"
          placeholder="Module name"
          type="text"
          onChange={handleChange}
        />
      </Form.Item>

        <Form.Item
          name="week"
          label={weekTitle}
          rules={[
            { required: true, message: "Please provide the module week" },
          ]}
        >
          <Input
            size="large"
            name="week"
            placeholder="1"
            type="number"
            onChange={handleChange}
          />
        </Form.Item>

        {/* <Form.Item label={weekTitle} name="week" style={{ width: "50%" }} 
    onChange={(value) => {
      console.log("week",parseInt(value.nativeEvent.data))
      setModuleInfo({
        ...moduleInfo,
        week: parseInt(value.nativeEvent.data)
      });
    }}
    >
              <Input size="large" min={1} max={parseInt(week)} defaultValue={1}/>
            </Form.Item> */}
        <Form.Item
          name="description"
          label="Module content"
          rules={[
            { required: true, message: "Please provide the module name" },
          ]}
        >
          <Editor
            apiKey={apiKey}
            initialValue={moduleContent}
            init={{
              height: 500,
              menubar: true,
              plugins: [
                "aprint preview importcss searchreplace autolink autosave save directionality visualblocks visualchars fullscreen link template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount textpattern noneditable help charmap quickbars emoticons",
              ],
              toolbar:
                "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor casechange removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | showcomments addcomment",
            }}
            onEditorChange={handleEditorChange}
          />
        </Form.Item>
        <Form.Item name="tags" label="Tags">
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Module tags"
            onChange={(value) => {
              setModuleInfo({
                ...moduleInfo,
                tags: value.toString(),
              });
            }}
          >
            {children}
          </Select>
        </Form.Item>

<Form.Item name="resources" label="Resources">
  <Select
    mode="tags"
    style={{ width: "100%" }}
    placeholder="Module resources"
    onChange={(value) => {
      setModuleInfo({
        ...moduleInfo,
        resources: value.toString(),
      });
    }}
  >
    {children}
  </Select>
  ,
</Form.Item>

<Form.Item name="videos" label="Video Links">
  <Select
    mode="tags"
    style={{ width: "100%" }}
    placeholder="Youtube Video Links"
    onChange={(value) => {
      setModuleInfo({
        ...moduleInfo,
        videos: value,
      });
    }}
  >
    {children}
  </Select>
  ,
</Form.Item>
      </div>
    ),

    // Module preview here
    preview: (
      <div>
        {/* {{__html:  moduleContent}} */}
        <div dangerouslySetInnerHTML={{ __html: moduleContent }} />
      </div>
    ),
  };


  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <h2>{courseName}</h2>
      </Space>
      <Card
        style={{ width: "100%" }}
        title="New module"
        extra={
          <Button
            type="primary"
            size="large"
            // className="container-100"
            disabled={disablePublish}
            htmlType="submit"
            loading={loading}
            onClick={handleSubmit}
          >
            Publish
          </Button>
        }
        tabList={tabList}
        activeTabKey={state.key}
        onTabChange={(key) => {
          onTabChange(key, "key");
        }}
      >
        <Form
          layout="vertical"
          hideRequiredMark
          onFinish={handleSubmit}
          className="mb-4"
        >
          {contentList[state.key]}
        </Form>
      </Card>
    </>
  );
};
const mapStateToProps = (state) => {
  return { moduleState: state.courses.addModule };
};

export default connect(mapStateToProps, { addModuleAction })(AddModule);
